import { useEffect, useState } from "react";
import { API_URL } from "@/lib/backend";

const BASE = API_URL;
const API = API_URL;
const offline = () => new Error("Os pagamentos ainda não estão disponíveis neste endereço.");

const detail = (data) => {
  const d = data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x?.msg ?? "").replace(/^Value error, /, "")).filter(Boolean).join(" ") || "Dados inválidos.";
  return "Ocorreu um erro. Tenta novamente.";
};

export const postJson = async (path, body, signal) => {
  if (!BASE) throw offline();
  let res;
  try {
    res = await fetch(`${API}${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), signal });
  } catch {
    throw new Error("Sem ligação ao servidor. Tenta novamente.");
  }
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(detail(data));
  return data;
};

export const getJson = async (path) => {
  if (!BASE) throw offline();
  const res = await fetch(`${API}${path}`);
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(detail(data));
  return data;
};

// Modo de teste dos pagamentos (só nesse caso aparecem os avisos de teste). Enquanto não se sabe, assume que NÃO é teste: nunca mostra o aviso por engano.
let testMode = null;
export const useTestMode = () => {
  const [v, setV] = useState(testMode ?? false);
  useEffect(() => {
    if (testMode !== null) return;
    getJson("/payments/mode").then((d) => { testMode = !!d?.test_mode; setV(testMode); }).catch(() => null);
  }, []);
  return v;
};

// Portes grátis a partir deste valor em peças (já com o desconto). Tem de coincidir com FREE_SHIPPING_CENTS em worker/orders.ts.
export const FREE_SHIPPING_EUR = 100;
